import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "@/components/ui/select";
import { COMPANY_LIST } from "../../companies";

export const DepartmentFormDialog = ({ form, setForm, emps, saving, onSave, onClose }) => (
  <Dialog open={!!form} onOpenChange={(o) => !o && onClose()}>
    <DialogContent className="max-w-[460px]">
      <DialogHeader>
        <DialogTitle>{form?._edit ? "Modifica reparto" : "Nuovo reparto"}</DialogTitle>
        <DialogDescription className="sr-only">Modulo per inserire o modificare un reparto aziendale.</DialogDescription>
      </DialogHeader>
      {form && (
        <div className="space-y-3">
          <div>
            <label className="block text-[12px] font-semibold text-gray-600 mb-1">Nome reparto *</label>
            <input value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="w-full border border-gray-300 rounded-sm px-3 py-2 text-[14px] outline-none focus:border-[#16345c]" />
          </div>
          <div>
            <label className="block text-[12px] font-semibold text-gray-600 mb-1">Descrizione</label>
            <input value={form.description} onChange={(e) => setForm({ ...form, description: e.target.value })} className="w-full border border-gray-300 rounded-sm px-3 py-2 text-[14px] outline-none focus:border-[#16345c]" />
          </div>
          <div>
            <label className="block text-[12px] font-semibold text-gray-600 mb-1">Società</label>
            <Select value={form.company || "teleborsa"} onValueChange={(v) => setForm({ ...form, company: v })}>
              <SelectTrigger data-testid="dept-company"><SelectValue /></SelectTrigger>
              <SelectContent>
                {COMPANY_LIST.map((c) => <SelectItem key={c.code} value={c.code}>{c.label}</SelectItem>)}
              </SelectContent>
            </Select>
          </div>
          <div>
            <label className="block text-[12px] font-semibold text-gray-600 mb-1">Responsabile</label>
            <Select value={form.manager_id || "none"} onValueChange={(v) => setForm({ ...form, manager_id: v === "none" ? "" : v })}>
              <SelectTrigger><SelectValue placeholder="Nessuno" /></SelectTrigger>
              <SelectContent>
                <SelectItem value="none">Nessuno</SelectItem>
                {emps.map((e) => <SelectItem key={e.id} value={e.id}>{e.name} ({e.matricola})</SelectItem>)}
              </SelectContent>
            </Select>
            <p className="text-[11px] text-gray-400 mt-1">Il dipendente scelto diventa "Responsabile" del reparto.</p>
          </div>
        </div>
      )}
      <DialogFooter>
        <button onClick={onClose} className="px-4 py-2 text-[13px] font-semibold text-gray-600 hover:bg-gray-100 rounded-sm transition-colors">Annulla</button>
        <button onClick={onSave} disabled={saving} className="px-4 py-2 text-[13px] font-bold text-white bg-[#16345c] hover:bg-[#0d1b2f] rounded-sm transition-colors disabled:opacity-60">{saving ? "Salvataggio..." : "Salva"}</button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);
